// @ts-nocheck
// SignModule.jsx
import React, { useState, useEffect } from 'react';
import logo from 'assets/img/login-logo.png';
import { Box, Stack } from '@mui/material';
import PropTypes from 'prop-types';
import SignatureModule from '../components/SignatureModule';
import PdfDetails from '../components/PdfDetails/index';
import InfoCard from '../components/InfoCard/index';
import useSignatureClientConfirmation from '../../hooks/useSignatureClientConfirmation';
import MuiButton from '../../../common/Button';
import { MAX_COMMENT_LENGTH } from '../../../common/constants/constants';

const SignModule = ({
  handleClickOpen,
  handleApproved,
  comment,
  setComment,
  signatoryName,
  setSignatoryName,
}) => {
  const {
    signatureId,
    savedSignature,
    isSignatureLoading,
    errorMessage,
    isDialogOpen,
    setIsDialogOpen,
    toggleSignaturePad,
    removeSignature,
    clear,
    saveSignature,
    sigCanvas,
  } = useSignatureClientConfirmation();
  const [isApproved, setIsApproved] = useState(false);

  useEffect(() => {}, [signatureId]);

  const approveDocument = () => {
    handleApproved(true, signatureId);
    setIsApproved(true);
  };

  return (
    <Stack
      direction="column"
      justifyContent="center"
      alignItems="center"
      spacing={2}
      px={{ xs: 2, sm: 4 }}
      py={{ xs: 2, sm: 4 }}
      pb={{ xs: 8, sm: 8 }}
      sx={{
        background: '#fff',
        maxWidth: '845px',
        borderRadius: { xs: '0', sm: '16px' },
      }}
    >
      <Box sx={{ width: { xs: '130px', sm: '164px' } }}>
        <img className="logo" src={logo} alt="Logo" />
      </Box>
      <PdfDetails />
      <InfoCard
        message="Please ensure that all details on the docket are accurate before
signing, as signatures cannot be undone once captured."
      />
      <SignatureModule
        savedSignature={savedSignature}
        isSignatureLoading={isSignatureLoading}
        errorMessage={errorMessage}
        isDialogOpen={isDialogOpen}
        toggleSignaturePad={toggleSignaturePad}
        removeSignature={removeSignature}
        clear={clear}
        saveSignature={saveSignature}
        sigCanvas={sigCanvas}
        setIsDialogOpen={setIsDialogOpen}
        setComment={setComment}
        comment={comment}
        signatoryName={signatoryName}
        setSignatoryName={setSignatoryName}
      />

      <Stack
        direction="row"
        justifyContent="center"
        alignItems="center"
        spacing={{ xs: 1, sm: 2 }}
        mt={3}
        sx={{ width: { xs: '100%', sm: 'auto' } }}
      >
        <Box sx={{ width: { xs: '100%', sm: 'auto' } }}>
          <MuiButton
            fullWidth
            variant="contained"
            color="error"
            size="small"
            onClick={handleClickOpen}
            disabled={savedSignature}
          >
            Reject
          </MuiButton>
        </Box>
        <Box sx={{ width: { xs: '100%', sm: 'auto' } }}>
          <MuiButton
            fullWidth
            color="primary"
            variant="contained"
            size="small"
            onClick={approveDocument}
            disabled={
              !savedSignature ||
              isApproved ||
              comment?.length > MAX_COMMENT_LENGTH ||
              !signatoryName
            }
          >
            Approve Daywork
          </MuiButton>
        </Box>
      </Stack>
    </Stack>
  );
};

export default SignModule;

SignModule.propTypes = {
  handleClickOpen: PropTypes.func.isRequired,
  handleApproved: PropTypes.func.isRequired,
};
